import { TYPE_LOCKS, DIRECTION_VERT, DIRECTION_HORZ } from '../const'

export default (state, type, pos) => {
    let dir = null

    switch (pos) {
        case 'top':
        case 'bottom':
            dir = DIRECTION_VERT
            break
        case 'left':
        case 'right':
            dir = DIRECTION_HORZ
            break
    }

    if (!dir || !state[TYPE_LOCKS][type]) {
        return false
    }

    return state[TYPE_LOCKS][type][dir]
}
